var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7272 4.06976L5.76816 9.05899L10.7272 14.0181H14.4805V18.0878H9.03904L-0.00487709 9.05899L9.03904 0H14.4805V4.06976H10.7272Z",
    fill: "#0646A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessT);
export default __webpack_public_path__ + "static/media/lessT.0ab777243f2d512e7fe6c5dd81603a4a.svg";
export { ForwardRef as ReactComponent };